import React from 'react';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';
import PropdocsModal from '../../modal/PropdocsModal';
import styles from './styles.module.scss';

type MessageData = {
  message: string;
  sentBy: string;
  sentAt: string;
  documentTitle: string;
  actionText: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  messageData: MessageData;
};

const ShowSigningPrepMessageModal = ({ isOpen, onClose, messageData }: Props) => {
  return (
    <PropdocsModal
      show={isOpen}
      setShow={onClose}
      size="lg"
      title={<FormattedMessage id="title.document-message" defaultMessage="Document Message" />}
    >
      <div className={styles.signingPrepModalContent}>
        <div className={styles.signingPrepHeader}>
          <div>
            <div className="font-weight-bold">
              From: <span className="ml-1 font-weight-normal">{messageData.sentBy}</span>
            </div>
            <div className="font-weight-bold">
              Document: <span className="ml-1 font-weight-normal">{messageData.documentTitle}</span>
            </div>
            <div className="font-weight-bold">
              Activity: <span className="ml-1 font-weight-normal">{messageData.actionText}</span>
            </div>
          </div>
          <div>
            <span>{dayjs(messageData.sentAt).format('LLL')}</span>
          </div>
        </div>
        <div className={styles.signingPrepBody}>
          <div className="font-weight-bold pb-2">Message:</div>
          <div>{messageData.message}</div>
        </div>
      </div>
    </PropdocsModal>
  );
};

export default ShowSigningPrepMessageModal;
